import {
  FETCH_DASHBOARD_LOADING,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE
} from '../Types/missionTypes';

import api from '../config/api';

const API_URL = process.env.REACT_APP_TRAVEL_URI;

export const getMissionsBetweenDates = (startDate, endDate) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: FETCH_DASHBOARD_LOADING
      });
      api
        .get(`${API_URL}Mission/getMissionsBetweenDates/${startDate}/${endDate}`)
        .then(async response => {
          const data = response.data.data;
          dispatch({
            type: FETCH_DASHBOARD_SUCCESS,
            payload: data
          });
          resolve(data);
        })
        .catch(error => {
          const errorMsg = error.response.data.message;
          dispatch({
            type: FETCH_DASHBOARD_FAILURE,
            payload: errorMsg
          });
          reject(errorMsg);
        });
    });
  };
};

export const getExpensesBySL = (startDate, endDate) => {
  return api
    .get(`${API_URL}Mission/getExpensesBySL/${startDate}/${endDate}`)
    .then(async response => {
      const data = response?.data?.data;
      return data;
    })
    .catch(error => {
      const errorMsg = error.response?.data?.message;

      return errorMsg;
    });
};

export const getExpensesByEngagementCode = (startDate, endDate) => {
  return api
    .get(`${API_URL}Mission/getExpensesByEngagementCode/${startDate}/${endDate}`)
    .then(async response => {
      const data = response.data.data;
      return data;
    })
    .catch(error => {
      const errorMsg = error.response.data.message;

      return errorMsg;
    });
};

export const getCurrencies = () => {
  return api
    .get(`${API_URL}Currency`)
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      const errorMsg = error.message;
      return errorMsg;
    });
};
